<form #form="ngForm" novalidate>
    <div class="row container-form-list mb-4">
        <div class="col-12">           
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title">Segmentos</h6>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered">
                        <tbody>
                            <tr *ngFor="let entity of entities; let i = index">
                                <td class="col-classificacao">
                                    <sgt-classificacao-select
                                        #classificacaoSelect
                                        [(ngModel)]="entity.idClassificacao"
                                        (ngModelChange)="onChangeClassificacao(i)"
                                        [(classificacao)]="entity.classificacao"
                                        [tipoClassificacaoFilterRequired]="true"
                                        [idTipoClassificacao]="entity.idTipoClassificacao"
                                        [nomeTipoClassificacao]="entity.tipoClassificacao?.nome"
                                        [idClassificacaoPai]="obrigarHierarquia ? entities[i-1]?.idClassificacao : null"
                                        [somenteAtivas]="somenteClassificacoesAtivas"
                                        name="idClassificacao_{{i}}"
                                        id="idClassificacao_{{i}}"
                                        [required]="entity.obrigatorio"
                                        [disabled]="!canEdit || !entity.canEdit"
                                        #classificacao="ngModel">
                                    </sgt-classificacao-select>
                                    <sgt-form-control-error
                                        *ngIf="classificacao.errors && classificacao.errors.required && classificacao.dirty"
                                        msgError="O segmento é obrigatório">
                                    </sgt-form-control-error>                                                                    
                                </td>
                            </tr>
                            <tr *ngIf="entities?.length === 0" class="no-record">
                                <td class="text-center">
                                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum segmento adicionado
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</form>